import { styled, Typography } from '@mui/material'

const FinancialLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontFamily: 'sweet-sans-pro, sans-serif',
  fontWeight: 600,
  fontSize: '0.75rem',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
}))

export default FinancialLabel
